// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_card_item_with_icon-module__iconBlock--1pRO_{position:relative;padding:0 24px 16px}.entity_card_item_with_icon-module__iconSubtitle--2uaTO{font-weight:500}\n", ""]);
// Exports
exports.locals = {
	"iconBlock": "entity_card_item_with_icon-module__iconBlock--1pRO_",
	"iconSubtitle": "entity_card_item_with_icon-module__iconSubtitle--2uaTO"
};
module.exports = exports;
